import { RoleFeatureModel } from './RoleFeatureModel';
import { IOrganizationViewModel } from './OrganizationModel';

export interface IProjectMasterViewModel {
    project_Id?:number;
    project_Code : string;
    project_Description : string;
    project_Short_Description : string;
    job_Code:string
    project_Type:string
    project_URL?:string
    project_Logo_URL?:string
    start_Date? : Date
    end_Date? : Date
    is_Cloud_Storage?:boolean
    is_Active:boolean
    user_Id : number
    iC_Id :number
    ic_Description?:string
    doc_Number_Format?:string
    group_Id ? : number
    client? : string
    consultant?: string
    isoFormatNo?: string
    latitude?: number
    longitude?:number
  }

  export interface IProjectCreateModel{
    project : IProjectMasterViewModel,
    isImport : boolean,
    icList: RoleFeatureModel[],
    businessGroups: IOrganizationViewModel[] ;
  }

  export interface IEipJobsRequestModel{
    doptCode:string,
    dtCode:number,
    userId:number,
    searchText:string,
  }

  export interface IEdrcJobsRequestModel{
    search_Text:string,
    group_Code:string,
  }

  export interface IEnableSimilarProjectViewModel {

      From_Project_Id :string
      To_Project_Id :string
      From_Group_Id :string
      To_Group_Id :string
      Member_Id? :number
  }